import { v4 as uuidv4 } from 'uuid'

function generateTransactionId() {
    return uuidv4()
}

export const SENTRY_TRANSACTION_ID = generateTransactionId()

/**
 * Function to check if the error is from your library
 */
export function isRelevantError(event) {
    if (!event.exception || !event.exception.values) {
        return false
    }

    return event.exception.values.some((exception) => {
        if (!exception.stacktrace || !exception.stacktrace.frames || exception.stacktrace.frames.length === 0) {
            return false
        }

        const frames = exception.stacktrace.frames
        const lastFrame = frames[frames.length - 1]

        const filename = lastFrame.filename || ''
        const module = lastFrame.module || ''

        return (
            filename.includes('payment-api.js') || module.includes('payment-api.js') ||
            filename.includes('payment-page.js') || module.includes('payment-page.js')
        )
    })
}
